import ChevronLeftIcon from '@mui/icons-material/ChevronLeftRounded';
import {
  Box, Button,
  Typography,
} from '@mui/material';
import React from 'react';
import useHistory from '../Hooks/useHistory/useHistory';

interface PageHeaderProps {
  title: React.ReactNode;
  children?: React.ReactNode;
}

export function BasePageHeader(props: PageHeaderProps) {
  const { title, children } = props;
  const { goBack, hasHistory } = useHistory();
  return (
    <Box className="header">
      <div className="title">
        {hasHistory && (
        <Button onClick={() => { goBack(); }} className="nav-previous">
          <ChevronLeftIcon />
        </Button>
        )}
        {title}
      </div>
      {children}
    </Box>
  );
}

export default function PageHeader(props: { title: string; children?: React.ReactNode }) {
  const { title, children } = props;
  return (
    <BasePageHeader title={<Typography variant="h1">{title}</Typography>}>
      {children}
    </BasePageHeader>
  );
}
